(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("react-arcgis", ["react"], factory);
	else if(typeof exports === 'object')
		exports["react-arcgis"] = factory(require("react"));
	else
		root["react-arcgis"] = factory(root["React"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__) {
return 